import Vue from 'vue';
import {
  fetchProductData,
  fetchMapIncome,
  fetchOrderGoodsData,
  getDetailData,
  getMapIncome,
  getOrderGoodsData,
} from '@/api/income';

export function useProduct() {
  const state = Vue.observable({
    type: '1',
    ProductDetailData: [
      {
        align: 'center',
        classname: 'tb-date',
        label: '日期',
        prop: 'date',
      },
      // {
      //   align: 'center',
      //   classname: 'tb-name',
      //   label: '名称',
      //   prop: 'product-name'
      // },
      // {
      //   align: 'center',
      //   classname: 'tb-name',
      //   label: '收入来源',
      //   prop: 'product-name'
      // },
      {
        align: 'center',
        classname: 'tb_money_type',
        label: '收入类型',
        prop: 'money_type',
      },
      {
        align: 'center',
        classname: 'tb-num',
        label: '数额',
        prop: 'num',
      },
      // {
      //   align: 'center',
      //   classname: 'tb-name',
      //   label: '触发器广告收入',
      //   prop: 'product-name'
      // },
      // {
      //   align: 'center',
      //   classname: 'tb-name',
      //   label: '内购商品收入',
      //   prop: 'product-name'
      // },
      // {
      //   align: 'center',
      //   classname: 'tb-name',
      //   label: '通行证收入',
      //   prop: 'product-name'
      // }
    ],
    ProductDetailDataMap: [
      {
        align: 'center',
        classname: 'tb-date',
        label: '日期',
        prop: 'date',
      },
      {
        align: 'center',
        classname: 'tb-name',
        label: '商品ID',
        prop: 'id',
      },
      {
        align: 'center',
        classname: 'tb-name',
        label: '商品名称',
        prop: 'name',
      },
      {
        align: 'center',
        classname: 'tb_money_type',
        label: '货币类型',
        prop: 'money_type',
      },
      {
        align: 'center',
        classname: 'tb-num',
        label: '单价',
        prop: 'price',
      },
      {
        align: 'center',
        classname: 'tb-name',
        label: '购买数量',
        prop: 'num',
      },
      {
        align: 'center',
        classname: 'tb-name',
        label: '购买人数',
        prop: 'player',
      },
    ],
    orderGoodsData: [
      {
        align: 'center',
        classname: 'tb-date',
        label: '日期',
        prop: 'date',
      },
      {
        align: 'center',
        classname: 'tb-name',
        label: '商品ID',
        prop: 'ItemID',
      },
      {
        align: 'center',
        classname: 'tb-name',
        label: '商品名称',
        prop: 'ItemName',
      },
      // {
      //   align: 'center',
      //   classname: 'tb_money_type',
      //   label: '货币类型',
      //   prop: 'money_type',
      // },
      {
        align: 'center',
        classname: 'tb-num',
        label: '单价',
        prop: 'CostPrice',
      },
      // {
      //   align: 'center',
      //   classname: 'tb-name',
      //   label: '消费者迷你号',
      //   prop: 'BuyerUin',
      // },
      {
        align: 'center',
        classname: 'tb-name',
        label: '购买数量',
        prop: 'buy_num',
      },
      // {
      //   align: 'center',
      //   classname: 'tb-name',
      //   label: '货币消耗数量',
      //   prop: 'player',
      // },
    ],
    queryApi: getDetailData,
    exportApi: fetchProductData,
  });
  const changeType = async (productType = '1') => {
    state.type = productType;
    if (productType == '2') {
      state.queryApi = getMapIncome;
      state.exportApi = fetchMapIncome;
    } else if (productType == '1') {
      state.queryApi = getDetailData;
      state.exportApi = fetchProductData;
    } else {
      state.queryApi = getOrderGoodsData;
      state.exportApi = fetchOrderGoodsData;
    }
  };

  return {
    productState: state,
    productModel: { changeType },
  };
}
